import { useEffect, useState } from "react";
import { IUserViewObj } from "../../../../shared/apiServices/IApiInterfaces";
import './EditUsers.scss';
type Props = {
    user: IUserViewObj | undefined;
    saveUser(user: IUserViewObj): any;
}

const EditUsers = ({ user, saveUser }: Props) => {

    const [userToEdit, setUserToEdit] = useState<IUserViewObj>();
    const [isAdmin, setIsAdmin] = useState<boolean>();

    useEffect(() => {
        setUserToEdit(user);
        setIsAdmin(user?.admin);
    }, [user]);


    const changeAdmin = () => {
        setIsAdmin(!isAdmin);
    }

    const handleSaveUser = () => {
        if (userToEdit) {
            userToEdit.admin = isAdmin as boolean;
            saveUser(userToEdit);
        }
    }

    return (

        <div className='row d-flex justify-content-end'>
            <div className='d-flex d-center'>
                <div className="input-field col s6">
                    <input
                        id="editFName"
                        aria-label="First Name"
                        type="text"
                        value={userToEdit?.firstName} readOnly
                    />
                    <label className='editLabels'>
                        First Name
                    </label>
                </div>
                <div className="input-field col s6">
                    <input
                        id="editLName"
                        aria-label="Last Name"
                        type="text"
                        value={userToEdit?.lastName} readOnly
                    />
                    <label className='editLabels'>
                        Last Name
                    </label>
                </div>
            </div>
            <div className="row">
                <div className="input-field col s6">
                    <label className={'active'}>
                        Admin User
                    </label>

                    <label>
                        <input type='checkbox' checked={isAdmin} onChange={changeAdmin} />
                        <span></span>
                    </label>
                </div>
            </div>
            <div className="editSaveBtn">
                <button
                    aria-label="Save"
                    className="btn btn-primary"
                    onClick={() => handleSaveUser()}>
                    Save
                </button>
            </div>
        </div>
    );
}

export default EditUsers;